<script setup>
import { useLayout } from '@/composables/layout';
import Drawer from 'primevue/drawer';
import { ref } from 'vue';

const { toggleMenu } = useLayout();
const toggleUserProfile = ref(false);
</script>

<template>
	<div class="layout-topbar">
		<div class="layout-topbar-logo-container">
			<button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
				<i class="fa-solid fa-bars"></i>
			</button>
			<router-link to="/" class="layout-topbar-logo">
				<span class="font-bold tracking-tight text-heading">
					MC Booking Hub
				</span>
			</router-link>
		</div>

		<div class="layout-topbar-actions">
			<Drawer v-model:visible="toggleUserProfile" position="right" :style="{ width: '300px' }"
				:closeOnEscape="true" :showHeader="false">
				<UserProfile />
			</Drawer>
			<button type="button" class="layout-topbar-action" @click="toggleUserProfile = true">
				<i class="fa-regular fa-user"></i>
				<span>{{ $t('settings.profile') }}</span>
			</button>
		</div>
	</div>
</template>
